// @flow
import * as React from 'react';
import Portal from './../common/Portal';
import Button from './../common/Button';
import { getFilesFromDropEvent } from '../util/DndUtil';
import { canUseModernUploader, getFileNodesFromDropEvent } from '../util/DndUtilModern';
import uploadAssets from '../upload/uploadAssets';
import Store from '../store/Store';
import { IS_DRAGGING_FILE, SHOW_UPLOADS, BREADCRUMB_ASSETS } from '../store/Constants';
import { getRemotePathFromBreadcrumb } from '../store/StoreUtil';
import TextWithEllipsis from '../common/TextWithEllipsis';
import _ from 'lodash';

import './DropzoneModal.css';
import { RepoItem } from '../autogenerated/ZoomBridge';
import ViewUtil from '../ViewUtil';
import t from '../i18n/I18n';
import { ThemeSetup } from '../themes/ThemeSetup';
import System from '../basic/System';
import KeyboardShortcuts from '../keyboard-shortcuts/KeyboardShortcuts';
import KeydownConfig from '../keyboard-shortcuts/KeydownConfig';
import { KeyCode } from '../util/Constants';

const debug = require('../debug/debug')('wc:dnd:DropzoneModal');

type Props = {};

type State = {
  isOver: boolean
};

export default class DropzoneModal extends React.Component<Props, State> {
  state = {
    isOver: false
  };

  componentDidMount() {
    this.addEventListener();
  }

  componentWillUnmount() {
    this.removeKeyListener();
  }

  addEventListener = () => {
    KeyboardShortcuts.add(new KeydownConfig('DROP_ZONE_MODAL', this.onClose, [KeyCode.ESCAPE]));
  };

  removeKeyListener = () => {
    KeyboardShortcuts.remove('DROP_ZONE_MODAL');
  };

  render() {
    return (
      <Portal defaultOpen={true} closeOnEsc={true} closeOnOutsideClick={true}>
        {/* <div name="DropzoneModal" onDragLeave={this.onRootDragLeave} onDrop={this.onRootDrop}>
          <div className="dropzone-outer" onDragLeave={this.onRootDragLeave} onDrop={this.onRootDrop}> */}
        <div name="DropzoneModal" onDrop={this.onRootDrop}>
          <div className="dropzone-outer" onDrop={this.onRootDrop}>
            <div
              className="dropzone-inner"
              style={{
                backgroundImage: 'url(images/upload.svg)',
                backgroundColor: this.state.isOver ? 'var(--primary-style-shadow)' : ''
              }}
              onDragEnter={this.onDragEnter}
              onDragLeave={this.onDragLeave}
              onDragOver={this.onDragOver}
              onDrop={this.onDrop}>
              <div className="flex-row align-center justify-center" style={{ pointerEvents: 'none' }}>
                <span>{t('DROP_FILE_MSG')} </span>
                <TextWithEllipsis
                  textStyle={{ fontSize: 16, maxWidth: 500, color: 'var(--primary-font-color-selected)' }}
                  text={getRemotePathFromBreadcrumb()}
                  responsive={false}
                />
              </div>
            </div>
            <Button icon={ThemeSetup.getImageURL('cross.svg')} onClick={this.onClose} />
          </div>
        </div>
      </Portal>
    );
  }

  onRootDragLeave = (e: DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    this.onClose();
  };

  onRootDrop = (e: DragEvent) => {
    // e.preventDefault();
    // e.stopPropagation();
    this.onClose();
  };

  onDragEnter = (e: DragEvent) => {
    e.stopPropagation();
    e.preventDefault();
    this.setState({ isOver: true });
  };

  onDragOver = (e: DragEvent) => {
    e.stopPropagation();
    e.preventDefault();
  };

  onDragLeave = (e: DragEvent) => {
    e.stopPropagation();
    this.setState({ isOver: false });
  };

  onDrop = async (e: DragEvent) => {
    // e.preventDefault();
    // e.stopPropagation();
    debug('[onDrop()] e.target: ', e.target);

    let isModern: boolean = false;
    if (canUseModernUploader(e)) {
      isModern = true;
    }
    const files = isModern ? await getFileNodesFromDropEvent(e) : await getFilesFromDropEvent(e);
    debug('[onDrop()] files: ', files);

    if (!files.length) {
      debug('[onDrop()] no files. return');
      return;
    }

    let projectName: string;
    let uploadPath: string;
    const pwd: number[] = ViewUtil.getPwd();
    if (_.size(pwd) > 0) {
      const breadCrumAssets = _.size(pwd) > 0 ? Store.get(BREADCRUMB_ASSETS) : undefined;
      const projectRepoItem: RepoItem = _.head(breadCrumAssets); //Store.get(BREADCRUMB_ASSETS)[0].getName();
      if (projectRepoItem) {
        projectName = projectRepoItem.getName();
        uploadPath = getRemotePathFromBreadcrumb();
      }
    }
    uploadAssets.uploadAssetsAndImport(files, { isModernUpload: isModern, projectName: projectName, uploadPath: uploadPath });
    if (!System.isDesktop()) {
      Store.put(SHOW_UPLOADS, true);
    }
    this.onClose();
  };

  onClose = () => {
    Store.put(IS_DRAGGING_FILE, false);
  };
}
